import { render } from "./CreateAdtechUser.vue?vue&type=template&id=6e6a07b6"
import script from "./CreateAdtechUser.vue?vue&type=script&lang=js"
export * from "./CreateAdtechUser.vue?vue&type=script&lang=js"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__